'use client'

import * as React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import { cn } from 'lib/utils'
import { buttonVariants } from './button_v2'

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  theme,
  ...props
}) {
    const defaultClassNames = getDefaultClassNames();
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
     classNames={{
  months: cn('flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0', defaultClassNames.months),
  month: cn('space-y-4', defaultClassNames.month),
  caption: cn('flex justify-center pt-1 relative items-center', defaultClassNames.caption),
caption_label: theme === "dark" 
   ? 'text-white font-medium text-sm' 
   : cn('text-sm font-medium', defaultClassNames.caption_label),
     table: cn('w-full border-collapse', defaultClassNames.table),
  weekdays: cn('flex', defaultClassNames.weekdays),
 weekday: theme === "dark"
  ? "text-white/70 flex-1 text-center text-[0.8rem] font-normal"
  : "text-muted-foreground flex-1 text-center text-[0.8rem] font-normal",
  week: cn('flex w-full mt-2', defaultClassNames.week),
  row: cn('flex w-full mt-2', defaultClassNames.row),
 cell: cn(
  'h-9 w-9 text-center text-sm p-0 relative focus-within:relative focus-within:z-20',
  defaultClassNames.cell
),
 day: cn(
  buttonVariants({ variant: 'ghost' }),
  theme === "dark" ? 'text-white' : 'text-black',
  'h-9 w-9 p-0 rounded-none !h-9 !w-9 !px-0 !py-0 !rounded-none',
  defaultClassNames.day
),
day_range_start: theme === "dark"
  ? 'bg-blue-600 text-white rounded-none !h-9 !w-9 !px-0 !py-0'
  : 'bg-primary text-primary-foreground rounded-none !h-9 !w-9 !px-0 !py-0',
day_range_middle: theme === "dark"
  ? '!bg-blue-700/50 text-white rounded-none !h-9 !w-9 !px-0 !py-0'
  : 'bg-primary/30 text-primary-foreground rounded-none !h-9 !w-9 !px-0 !py-0',
day_range_end: theme === "dark"
  ? 'bg-blue-600 text-white rounded-none !h-9 !w-9 !px-0 !py-0'
  : 'bg-primary text-primary-foreground rounded-none !h-9 !w-9 !px-0 !py-0',
day_selected: theme === "dark"
  ? '!bg-blue-700 text-white hover:bg-blue-700'
  : 'bg-primary text-primary-foreground hover:bg-primary',
day_today: theme === "dark" ? "bg-accent text-black" : "bg-accent text-accent-foreground",
day_outside: theme === "dark"
  ? "day-outside text-white/50 aria-selected:bg-accent/50"
  : "day-outside text-muted-foreground aria-selected:bg-accent/50",
day_disabled: theme === "dark" ? "text-white/30 opacity-50" : "text-muted-foreground opacity-50",
  day_hidden: 'invisible',
  ...classNames,
}}
      components={{
        IconLeft: ({ ...props }) => <ChevronLeft className="h-4 w-4" />,
        IconRight: ({ ...props }) => <ChevronRight className="h-4 w-4" />,
      }}
      {...props}
    />
  )
}
Calendar.displayName = 'Calendar'

export { Calendar }